import {getDateFormat, getHourMinutes, tsToDate} from '../../../../library/dates';
import {useETicketDir} from '../../hooks/useETicketDir';
import * as css from './MemberDateBox.css';

interface MemberDateBoxProps {
    ts?: number;
    /* 'row' — day.month over the hour · 'square' — a large day over the month name */
    variant?: 'row' | 'square';
}

/* The date box shared by the subscription lists */
function MemberDateBox({ts, variant = 'row'}: MemberDateBoxProps) {
    const {lang} = useETicketDir();
    const isSquare = variant === 'square';
    // The month name is localized through tsToDate — getDateFormat applies no locale
    const day = ts ? getDateFormat(ts, isSquare ? 'D' : 'D.M') : '';
    const secondary = ts
        ? (isSquare ? tsToDate(ts, lang, undefined, 'MMM') : getHourMinutes(ts))
        : '';

    if(!day && !secondary) {
        return null;
    }

    return (
        <css.box $square={isSquare} data-cy="member-date-box">
            {day && <css.day $square={isSquare}>{day}</css.day>}
            {secondary && <css.secondary $square={isSquare}>{secondary}</css.secondary>}
        </css.box>
    );
}

export default MemberDateBox;
